import React from 'react'
import { Linea } from './Linea'
import styled from 'styled-components'

const Titulo = ({ titulo, color }) => {
    return (
        <Container>
            <h2 style={{ color: `${color}` }}>{titulo}</h2>
            <Linea color={color} />
        </Container>
    )
}

const Container = styled.div`
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
`

export default Titulo